import { ThunkDispatch } from "core-integration/src/store";
import { showElementSummary } from "core-integration/src/store/elements/thunks";
import { useDispatch } from "react-redux";
import { UnstyledRACButton } from "../../buttons/UnstyledRACButton";
import { ElementPhoto } from "../../ElementPhoto";
import Avatar from "../Avatar";
import { elementAvatarButton } from "./elementAvatar.css";
import { ElementAvatarProps } from "./types";

const ElementAvatar = ({ element, size = "medium" }: ElementAvatarProps) => {
  const dispatch = useDispatch<ThunkDispatch>();

  return (
    <Avatar size={size}>
      <UnstyledRACButton
        onPress={() => dispatch(showElementSummary(element.id))}
        className={elementAvatarButton}
      >
        <ElementPhoto elementId={element.id} alt={element.web_name} />
      </UnstyledRACButton>
    </Avatar>
  );
};

export default ElementAvatar;
